import axios from 'axios'
import { FulfillmentLocation } from '../models'

const FL_URL =
  'https://fulfillmentlocation.trdlnk.cimpress.io/v1/fulfillmentlocations'

export const getFLs = async (
  authorization: string,
  disableCaching?: boolean
): Promise<FulfillmentLocation[]> => {
  const flResponse = (
    await axios.get(FL_URL, {
      params: {
        showArchived: true,
      },
      headers: {
        authorization,
        'Cache-Control': 'no-cache',
        'x-cache-id': disableCaching ? Date.now() : undefined,
      },
    })
  ).data

  return flResponse.map((l: any) => {
    return {
      id: l.fulfillmentLocationId,
      name: l.name,
      address: {
        locality: l.dispatchAddressCity,
        countryCode: l.dispatchAddressCountry,
      },
      timezone: l.timeZone,
      fulfiller: { fulfillerId: l.fulfillerId },
      isArchived: l.archived,
    }
  })
}
